<div class="wrapper">
  <app-dialog-title
      [title]="'pages.userRecords.card.requestDetailsDialog.approvalNotNeeded.header' | translate"
      (close)="closeDialog()"
  ></app-dialog-title>
  
  <mat-dialog-content>
      <div class="dialog-content">
          <span class="description">
              {{ 'pages.userRecords.card.requestDetailsDialog.approvalNotNeeded.body' | translate }}
          </span>
      </div>
  </mat-dialog-content>

  <mat-dialog-actions>
      <button class="bciti-button no-transition bciti-button--blue" (click)="closeDialog()">
          {{ ('common.close' | translate)}}
      </button>
  </mat-dialog-actions>
</div>
